import React from "react";
type Props = { className?: string };

export const CreditCardIcon = ({ className }: Props) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M2.90574 2.1293C2.51861 2.1293 2.1293 2.47477 2.1293 2.99669V13.0011C2.1293 13.523 2.51861 13.8685 2.90574 13.8685H17.0938C17.4809 13.8685 17.8702 13.523 17.8702 13.0011V2.99669C17.8702 2.47477 17.4809 2.1293 17.0938 2.1293H2.90574ZM0.529297 2.99669C0.529297 1.67686 1.55158 0.529297 2.90574 0.529297H17.0938C18.4479 0.529297 19.4702 1.67686 19.4702 2.99669V13.0011C19.4702 14.3209 18.4479 15.4685 17.0938 15.4685H2.90574C1.55158 15.4685 0.529297 14.3209 0.529297 13.0011V2.99669Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0.529312 6.66719C0.529312 6.22536 0.887484 5.86719 1.32931 5.86719H18.6702C19.112 5.86719 19.4702 6.22536 19.4702 6.66719C19.4702 7.10902 19.112 7.46719 18.6702 7.46719H1.32931C0.887484 7.46719 0.529312 7.10902 0.529312 6.66719Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
